import React from 'react';
import VoxelMenuItemContainer from '../../../voxel/PopoverMenu/VoxelMenuItemContainer';
import { HeadCellImplementationProps } from '../KeywordTable/HeadCells/models';
import HeadCell from './HeadCell';
import HeadCellStandardOptions from './HeadCellStandardOptions';

export interface HeadCellBasicProps extends HeadCellImplementationProps {
  align?: 'left' | 'right' | 'center';
}

export const HeadCellBasic: React.FC<HeadCellBasicProps> = ({ align, basicConfig, basicState }) => {
  return (
    <HeadCell hasFilter={false} align={align} basicConfig={basicConfig} basicState={basicState}>
      <VoxelMenuItemContainer size="md">
        <HeadCellStandardOptions basicConfig={basicConfig} basicState={basicState} noDivider />
      </VoxelMenuItemContainer>
    </HeadCell>
  );
};

export default HeadCellBasic;
